import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import { priceParse } from "../../helpers/parsing";
import * as actions from "../actions/sessions";
import {
  GET_CURRENT_SESSIONS_REQUESTED,
  GET_SESSIONS_REQUESTED,
  GET_SESSION_REQUESTED,
  GET_SIMPLIFIED_SESSIONS_REQUESTED,
  GET_CONTRACT_DEPTH_REQUESTED,
} from "../types";
import moment from "moment";
import {
  convertAmountToFrontend,
  convertNumberToFrontend,
} from "../../helpers/convert";

export const getServerTime = (state) => state.utilities.serverTime;

function* watchGetCurrentSessions() {
  yield takeEvery(GET_CURRENT_SESSIONS_REQUESTED, getCurrentSessions);
}
function* watchGetSession() {
  yield takeEvery(GET_SESSION_REQUESTED, getSession);
}
function* watchGetSessions() {
  yield takeEvery(GET_SESSIONS_REQUESTED, getSessions);
}
function* watchGetSimplifiedSessions() {
  yield takeEvery(GET_SIMPLIFIED_SESSIONS_REQUESTED, getSimplifiedSessions);
}
function* watchGetContractDepth() {
  yield takeEvery(GET_CONTRACT_DEPTH_REQUESTED, getContractDepth);
}

function* getCurrentSessions(action) {
  try {
    const res = yield call(apiGetCurrentSessions, action.payload);
    const resSystemProcess = yield call(apiGetSystemProcess);
    let SESSION_TIME = resSystemProcess.data.find((item) => {
      return item.processName === "CONTRACT_PROCESS_TIME";
    });
    let SESSION_END_TIME;
    if (SESSION_TIME)
      SESSION_END_TIME = moment().set({
        hour: SESSION_TIME.endHour,
        minute: SESSION_TIME.endMinute,
        second: 0,
      });
    // let NOW = yield select(getServerTime);

    const NOW = yield call(nowData);

    let remainingTime = moment.duration(SESSION_END_TIME.diff(NOW?.data));
    let contractRemainingTime = moment
      .utc(remainingTime.asMilliseconds())
      .format("HH:mm:ss");

    yield put(
      actions.getCurrentSessionsSucceeded({
        id: res.data.id,
        sessionDate: res.data.sessionDate,
        maximumPrice: res.data.maximumPrice,
        minimumPrice: res.data.minimumPrice,
        yekgSessionCreationType: res.data.yekgSessionCreationType,
        status: res.data.status,
      })
    );
    let contracts = res.data.contracts.reduce((acc, value) => {
      acc.push({
        id: value.id,
        contractName: value.contractName,
        bestBuyAmount: value.bestBuyAmount
          ? `${convertAmountToFrontend(
              value.bestBuyAmount
            )} - ${convertNumberToFrontend({
              num: value.bestBuyPrice,
              digit: 2,
            })} TL`
          : "0 - 0 TL",
        bestSpread: value.bestBuyPrice
          ? `${convertNumberToFrontend({
              num: Math.abs(
                Number((value.bestBuyPrice - value.bestSellPrice).toFixed(2))
              ),
              digit: 2,
            })} TL`
          : "0 TL",
        bestSellAmount: value.bestSellAmount
          ? `${convertAmountToFrontend(
              value.bestSellAmount
            )} - ${convertNumberToFrontend({
              num: value.bestSellPrice,
              digit: 2,
            })} TL`
          : "0 - 0 TL",
        maxMatchPrice: value.maxMatchPrice
          ? `${convertNumberToFrontend({
              num: value.maxMatchPrice,
              digit: 2,
            })} TL`
          : "0 TL",
        minMatchPrice: value.minMatchPrice
          ? `${convertNumberToFrontend({
              num: value.minMatchPrice,
              digit: 2,
            })} TL`
          : "0 TL",
        lastMatchAmount: value.lastMatchAmount
          ? convertAmountToFrontend(value.lastMatchAmount)
          : 0,
        lastMatchPrice: value.lastMatchPrice
          ? `${convertNumberToFrontend({
              num: value.lastMatchPrice,
              digit: 2,
            })} TL`
          : "0 TL",
        tradingVolume: value.totalAmount
          ? convertAmountToFrontend(value.totalAmount)
          : 0,
        weightedAverage: value.averagePrice
          ? `${convertNumberToFrontend({
              num: value.averagePrice,
              digit: 2,
            })} TL`
          : "0 TL",
        status: value.status,
        contractEndTime: contractRemainingTime,
        contractEndDate: moment(SESSION_END_TIME),
        type: value.type,
        description: value.description,
        maxPrice: res.data.maximumPrice,
        minPrice: res.data.minimumPrice,
      });
      return acc;
    }, []);
    yield put(actions.setCurrentContracts(contracts));
  } catch (err) {
    yield put(actions.getCurrentSessionsFailed());
  }
}

function* getSession(action) {
  try {
    const res = yield call(apiGetSession, action.payload);
    let contracts = res?.data?.contracts?.reduce((acc, value) => {
      acc.push({
        id: value.id,
        averagePrice: convertNumberToFrontend({
          num: value.averagePrice,
          digit: 2,
        }),
        contractName: value.contractName,
        bestBuyAmount: value.bestBuyAmount
          ? `${convertAmountToFrontend(
              value.bestBuyAmount
            )} - ${convertNumberToFrontend({
              num: value.bestBuyPrice,
              digit: 2,
            })} TL`
          : "0 - 0 TL",
        bestSpread: value.bestBuyPrice
          ? `${convertNumberToFrontend({
              num: Math.abs(
                Number((value.bestBuyPrice - value.bestSellPrice).toFixed(1))
              ),
              digit: 2,
            })} TL`
          : "0 TL",
        bestSellAmount: value.bestSellAmount
          ? `${convertAmountToFrontend(
              value.bestSellAmount
            )} - ${convertNumberToFrontend({
              num: value.bestSellPrice,
              digit: 2,
            })} TL`
          : "0 - 0 TL",
        maxMatchPrice: value.maxMatchPrice
          ? `${convertNumberToFrontend({
              num: value.maxMatchPrice,
              digit: 2,
            })} TL`
          : "0 TL",
        minMatchPrice: value.minMatchPrice
          ? `${convertNumberToFrontend({
              num: value.minMatchPrice,
              digit: 2,
            })} TL`
          : "0 TL",
        lastMatchAmount: value.lastMatchAmount
          ? convertAmountToFrontend(value.lastMatchAmount)
          : 0,
        lastMatchPrice: value.lastMatchPrice
          ? `${convertNumberToFrontend({
              num: value.lastMatchPrice,
              digit: 2,
            })} TL`
          : "0 TL",
        tradingVolume: value.totalAmount
          ? convertAmountToFrontend(value.totalAmount)
          : 0,
        weightedAverage: value.averagePrice
          ? `${convertNumberToFrontend({
              num: value.averagePrice,
              digit: 2,
            })} TL`
          : "0 TL",
        status: value.status,
        // contractEndTime: contractRemainingTime,
        //contractEndDate: moment(SESSION_END_TIME),
        type: value.type,
        description: value.description,
        maxPrice: res.data.maximumPrice,
        minPrice: res.data.minimumPrice,
        totalAmount: value.totalAmount,
      });
      return acc;
    }, []);
    yield put(actions.setSelectedSessionContracts(contracts));
  } catch (err) {
    console.log(err);
    yield put(actions.getSessionFailed());
  }
}

function* getSessions(action) {
  try {
    const res = yield call(apiGetSessions, action.payload);

    yield put(actions.getSessionsSucceeded(res.data));
  } catch (err) {
    yield put(actions.getSessionsFailed());
  }
}

function* getSimplifiedSessions(action) {
  try {
    const res = yield call(apiGetSimplifiedSessions, action.payload);
    let simplifiedSessions = res?.data?.items?.reduce((acc, value) => {
      acc.push({
        value: value.id,
        name: moment(value.sessionDate).format("DD-MM-YYYY"),
      });
      return acc;
    }, []);

    yield put(actions.getSimplifiedSessionsSucceeded(simplifiedSessions));
  } catch (err) {
    yield put(actions.getSimplifiedSessionsFailed());
  }
}

function* getContractDepth(action) {
  try {
    const resBuy = yield call(apiGetBuyContractDepth, action.payload);
    const resSell = yield call(apiGetSellContractDepth, action.payload);

    yield put(
      actions.getContractDepthSucceeded({
        buy: resBuy.data.items,
        buySmall: resBuy.data.items.slice(0, 5),
        sell: resSell.data.items,
        sellSmall: resSell.data.items.slice(0, 5),
      })
    );
  } catch (err) {
    yield put(actions.getContractDepthFailed());
  }
}

export default function* sessionSaga() {
  yield all([
    fork(watchGetCurrentSessions),
    fork(watchGetSession),
    fork(watchGetSessions),
    fork(watchGetContractDepth),
    fork(watchGetSimplifiedSessions),
  ]);
}

function apiGetCurrentSessions() {
  return API_GET("system-parameter/session/current/checked");
}

function apiGetSessions() {
  return API_GET("system-parameter/session", {
    page: 0,
    size: 1000,
  });
}

function apiGetSession(reqParams) {
  return API_GET("system-parameter/session/" + reqParams.sessionId);
}

function apiGetSimplifiedSessions() {
  return API_GET("system-parameter/session/simplified");
}

function apiGetBuyContractDepth(filter) {
  let URL = "exchange-order/search";
  if (filter.systemParticipant) {
    URL = "exchange-order/search_safe";
  }
  return API_GET(URL, {
    exchangeOrderType: "BUY",
    contractId: filter.contractId,
    showRemainingAmountZero: false,
    status: "OPEN",
    page: 0,
    size: 1000,
  });
}
function apiGetSellContractDepth(filter) {
  let URL =
    "exchange-order/byContractIdAndStatusOrderTypeRemainingAmountNotZero";
  if (filter.systemParticipant) {
    URL = "exchange-order/search_safe";
  }
  return API_GET(URL, {
    exchangeOrderType: "SELL",
    contractId: filter.contractId,
    showRemainingAmountZero: false,
    status: "OPEN",
    page: 0,
    size: 1000,
  });
}
function apiGetSystemProcess() {
  return API_GET("system-parameter/process");
}
function nowData() {
  return API_GET("system-date-time/full");
}
